// Compare two semver-ish version strings ("1.40.0") numerically: negative if a < b, 0 if equal,
// positive if a > b. A lexical string compare is wrong here — it ranks "1.9.0" above "1.40.0" —
// so we parse major.minor.patch and compare each field as a number.
export function compareSemver(a, b) {
    const pa = parse(a);
    const pb = parse(b);
    for (let i = 0; i < 3; i++) {
        if (pa[i] !== pb[i])
            return pa[i] - pb[i];
    }
    return 0;
}
function parse(version) {
    const m = /(\d+)\.(\d+)\.(\d+)/.exec(version);
    return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : [0, 0, 0];
}
